import { validations } from "./validations";

export const fiscalDataValidations = () => {
  return {
    unitNameRules: validations.generalMValidation({
      required: true,
      name: 'nombre de unidad',
    }),
    unitKeyRules: validations.generalFValidation({
      required: true,
      name: 'clave de unidad',
      maxLength: 4,
    }),
    skuRules: validations.generalMValidation({
      required: true,
      name: 'Número de identificación',
    }),
    productKeyRules: validations.generalFValidation({
      required: true,
      name: 'clave de producto',
      minLength: 8,
      maxLength: 8,
    }),
    billingDescriptionRules: validations.generalFValidation({
      name: 'descripción',
      required: true,
    }),
  };
};
